import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

interface StyledFooterRetailerLinksProps {
  center?: boolean;
}

export const StyledFooterRetailerInfo = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
  
    @media (min-width: ${Breakpoints.b1280}px) {
      flex-direction: row;
      gap: ${theme.size.static300};
      margin-bottom: ${theme.size.static500};
    }
  `
);

export const StyledFooterRetailerContact = styled.div(
  ({ theme }) => `
    margin-bottom: ${theme.size.static300};
  
    @media (min-width: ${Breakpoints.b1280}px) {
      margin: 0;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }
  `
);

export const StyledFooterRetailerCtas = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-grow: 1;
`;

export const StyledFooterRetailerPerson = styled.div(
  ({ theme }) => `
    margin-bottom: ${theme.size.static150};
  
    @media (min-width: ${Breakpoints.b1280}px) {
      margin-bottom: ${theme.size.static250};
      flex-grow: 1;
    }
  `
);

export const StyledFooterRetailerTimes = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.size.static400};
  
    @media (min-width: ${Breakpoints.b1280}px) {
      margin-bottom: 0;
    }
  
  `
);

export const StyledFooterRetailerAddress = styled.div(
  ({ theme }) => `
    margin-bottom: ${theme.size.static200};
  
    @media (min-width: ${Breakpoints.b1280}px) {
      margin-bottom: ${theme.size.static450};
    }
  `
);

export const StyledFooterRetailerLinks =
  styled.div<StyledFooterRetailerLinksProps>(
    ({ theme, center }) => `
    display: flex;
    gap: ${theme.size.static350};
    ${center && 'justify-content:center'}
  `
  );
